export default "__VITE_ASSET__DhQiHkPn__"